import axios from 'axios'
import config from "@/common/config";
import {message} from "ant-design-vue";
import router from "@/router";

const request = axios.create({
    baseURL: config.pyUrl,
    timeout: 300 * 1000*1000
})

request.interceptors.request.use(config => {
        config.headers = {
            'Content-Type': config.type || 'application/json'
        }

        if (config.type && config.type === 'multipart/form-data') {
            config.responseType = 'blob'
        }

        let token = localStorage.getItem('token')
        if (token) {
            config.headers.token = token
        } else {
            // router.push({
            //     path: '/login'
            // })
        }
        console.log(config)
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

request.interceptors.response.use((res) => {
    const code = res.status
    if (parseInt(code / 100) !== 2) {
        return Promise.reject(res)
    } else {
        return Promise.resolve(res.data)
    }
}, (error) => {
    if (error && error.response && error.response.status) {
        let message = error.response.data.message
        switch (error.response.status) {
            case 401:
                if (message === 'token不存在') {
                    message = '登录状态失效，请重新登录'
                    localStorage.removeItem("token");
                    router.push({
                        path: '/login'
                    })
                }
                error.message = message || '用户名或密码不正确'
                break
            case 500:
                error.message = message || '服务器端出错'
                break
            default:
                error.message = message || `连接错误${error.response.status}`
        }
    } else {
        // 超时处理
        if (JSON.stringify(error).includes('timeout')) {
            message.error('服务器响应超时，请刷新当前页')
        }
        error.message = '连接服务器失败'
    }
    throw error.message
})
export default request
